import { render } from "./talents-page.vue?vue&type=template&id=55e876be&ts=true"
import script from "./talents-page.vue?vue&type=script&lang=ts"
export * from "./talents-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__